import React, { useEffect } from 'react';
import { Box } from '@mui/material';

const AdvisoryCloudPlusOnboarding = () => {
  useEffect(() => {
    const widget = document.createElement('script');
    widget.type = 'text/javascript';
    widget.src = 'https://cdn.oncehub.com/mergedjs/so.js';

    const container = document.getElementById('SOIDIV_MariyaOnboardingCall');
    if (container) {
      container.appendChild(widget);
    }

    return () => {
      const scheduleOnceScript = document.getElementById(
        'SOIDIV_MariyaOnboardingCall'
      );
      if (scheduleOnceScript) {
        scheduleOnceScript.parentNode.removeChild(scheduleOnceScript);
      }
    };
  }, []);

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', px: 2 }}>
      <div
        id="SOIDIV_MariyaOnboardingCall"
        data-so-page="MariyaOnboardingCall"
        data-height="550"
        data-style="border: 1px solid #d8d8d8; min-width: 290px; max-width: 900px;"
        data-psz="10"
      />
      <Box sx={{ fontSize: '18px', textAlign: 'center', mt: 2 }}>
        <strong>Success, your advisory board has been upgraded!</strong>
        <br />
        Schedule a call with our team so we can help you plan your first board meeting, find the best advisors, and handle anything else for you.
      </Box>
    </Box>
  );
};

export default AdvisoryCloudPlusOnboarding;
